export const APP_ORIGIN = import.meta.env.VITE_APP_ORIGIN ?? "http://localhost:5173";
export const API_BASE = import.meta.env.VITE_API_BASE ?? "/api";

export const UPLOAD_MAX_FILES = 500;
export const UPLOAD_MAX_FILE_SIZE_BYTES = 500 * 1024 * 1024;
export const UPLOAD_MAX_FILE_SIZE_LABEL = "500 MB";
export const UPLOAD_CONCURRENCY = 4;

export const ACCEPTED_EXTENSIONS = [
  ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv", ".txt", ".rtf",
  ".png", ".jpg", ".jpeg", ".tif", ".tiff", ".zip",
];

export const UPLOAD_ACCEPT_ATTR = ACCEPTED_EXTENSIONS.join(",");
